const QUALTRICS_ROOT_URL = process.env.REACT_APP_QUALTRICS_URL || 'https://api.qualtrics.com/reference?showHidden=debd5#planned-response-collection';
// eslint-disable-next-line import/prefer-default-export
export const getQualtricsUrl = (path = '') => `${QUALTRICS_ROOT_URL}${path}`;
